module.exports = {
  not_found_title: "404エラー",
  not_found_sub_title: "お探しページは見つかりません。",
  not_found_button: "xIDサイトへ",

  mobile_launch_app_title: "アプリがみつかりません",
  mobile_launch_app_description1: "クロスアイディアプリをインストールしてください。",
  mobile_launch_app_description2: "アプリをインストールしているが、自動的にアプリが開かない場合は",
  mobile_launch_app_description3: "こちら",
  mobile_launch_app_description4: "へ。",
  mobile_launch_app_button: "インストールする",
  mobile_launch_app_dont_have_account: "xIDのアカウントはまた持ってない？",
}
